export const blockIconsActivitiesHowToVoteNew = (
	<span className='material-symbols-outlined'>how_to_vote</span>
);
